export const COUNTRIES_WITH_SUBSCRIPTIONS = ['gb', 'ae'];

export const isSubscriptionCountry = (country) => {
  const countryIso = country?.iso || country;

  return COUNTRIES_WITH_SUBSCRIPTIONS.includes(countryIso.toLowerCase());
};
